module.exports = __webpack_public_path__ + "img/live.400805e5.gif";